import React, { useEffect, useState } from 'react'
import { getApi } from '../../api/call.api'
import { urlApi } from '../../api/url.api'

const ShortLinkDropdown = ({ isTitle = true }) => {

    const [list, setList] = useState([{
        "_id": "6741856a351059fd7798ca0e",
        "domain": "advy.me",
        "status": 1
    }])

    async function getList() {
        let resp = await getApi(urlApi.getShortLinkDomainList);
        if (resp.responseCode === 200) {
            setList(resp.data);
        } else {
            setList([]);
        }
    }

    useEffect(() => {
        getList();
    }, []);

    return (
        <>
            {isTitle && <label htmlFor="" className='mb-1 font-semibold'>Short Link Domain</label>}
            <select name="" id="select-short-link-domain" className='form-control w-full'>
                {
                    list.map(item => (
                        <option key={item._id} selected={item?.domain == 'advy.me'} value={item.domain}>{item.domain}</option>
                    ))
                }
            </select>
        </>
    )
}

export default ShortLinkDropdown